import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
interface BaseProps {
  children: React.ReactNode;
  className?: string;
  size?: 'lg' | 'xl';
}
type ButtonProps = BaseProps & (({
  href: string;
} & React.AnchorHTMLAttributes<HTMLAnchorElement>) | ({
  href?: undefined;
} & React.ButtonHTMLAttributes<HTMLButtonElement>));
export function Button({
  children,
  className = '',
  size = 'lg',
  href,
  ...props
}: ButtonProps) {
  const classes = `
    relative group overflow-hidden rounded-full font-cinzel font-bold tracking-wider
    bg-gold-gradient text-[#0a0517] shadow-[0_0_40px_rgba(251,191,36,0.3)]
    transition-all duration-300 hover:shadow-[0_0_60px_rgba(251,191,36,0.5)]
    flex items-center justify-center gap-3 cursor-pointer
    ${size === 'xl' ? 'px-10 py-5 text-xl' : 'px-8 py-4 text-lg'}
    ${className}
  `;
  const content = <>
      <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-135" />
      <Sparkles className="w-5 h-5" data-id="element-136" />
      <span className="relative z-10" data-id="element-137">{children}</span>
      <Sparkles className="w-5 h-5" data-id="element-138" />
    </>;
  if (href) {
    return <motion.a whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} href={href} target="_blank" rel="noopener noreferrer" className={classes} {...props as React.AnchorHTMLAttributes<HTMLAnchorElement>} data-id="element-139">
        {content}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={classes} {...props as React.ButtonHTMLAttributes<HTMLButtonElement>} data-id="element-140">
      {content}
    </motion.button>;
}